<template>
  <div id="app">
    <div style="display: none">
      <audio
        preload="auto"
        loop
        ref="audioZd"
        src="https://hw-v.cztv.com/cztv/vod/2022/07/20/50bfe80afe4c46d09fbafecc8a5c5ac2/mp3_64k_mp3.mp3"
      ></audio>
      <audio
        preload="auto"
        loop
        ref="audioQt"
        src="https://hw-v.cztv.com/cztv/vod/2022/07/26/0b02baf44fda432b8c926bafcabdccfd/mp3_64k_mp3.mp3"
      ></audio>
      <audio
        preload="auto"
        loop
        ref="audioOj"
        src="https://hw-v.cztv.com/cztv/vod/2022/07/28/9daa49d3ed594a4db48e76dbae66bc00/mp3_64k_mp3.mp3"
      ></audio>
    </div>
    <!-- 加载页 -->
    <transition name="fade">
      <LoadingLayer
        v-if="shwoLoadPage"
        @startvideo="start"
        :progress="progress"
      />
    </transition>
    <!-- 加载页 -->

    <!-- 浙东唐诗之路 -->
    <transition name="fade">
      <MountainZd
        :visitedAll="visitedAll"
        :zdAudioPlaying="zdAudioPlaying"
        @endvisit="endVisit"
        @hideroad="hideRoad"
        @playmusic="playmusic"
        v-if="showMountZd"
      />
    </transition>
    <!-- 浙东唐诗之路 -->
    <!-- 瓯江山水诗路 -->
    <transition name="fade">
      <MountainOj
        :visitedAll="visitedAll"
        :ojAudioPlaying="ojAudioPlaying"
        @endvisit="endVisit"
        @hideroad="hideRoad"
        @playmusic="playmusic"
        v-if="showMountOj"
      />
    </transition>
    <!-- 瓯江山水诗路 -->
    <!-- 钱塘江诗路 -->
    <transition name="fade">
      <MountainQt
        :visitedAll="visitedAll"
        :qtAudioPlaying="qtAudioPlaying"
        @endvisit="endVisit"
        @hideroad="hideRoad"
        @playmusic="playmusic"
        v-if="showMountQt"
      />
    </transition>
    <!-- 钱塘江诗路 -->

    <!-- 地图页 -->
    <div class="home-map" v-show="showHomeMap">
      <!-- <img class="map-intro abs" src="./assets/img/map_intro.png" alt="" /> -->
      <transition name="fade">
        <div class="map-box abs" v-show="showRoadBtn">
          <!-- <img class="map" src="./assets/img/map.png" alt="" /> -->
          <div @click="showRoad('qt')" class="road-qt-btn abs">
            <img class="base-img" src="./assets/img/road_qt_btn.png" alt="" />
            <!-- <div class="light abs"></div> -->
            <!-- <span class="click-item abs click1"></span>
            <span class="click-item abs click2"></span> -->
            <img
              class="click-tips abs"
              src="./assets/img/click_tips.gif"
              alt=""
            />
          </div>

          <div @click="showRoad('zd')" class="road-zd-btn abs">
            <img class="base-img" src="./assets/img/road_zd_btn.png" alt="" />
            <!-- <div class="light abs"></div> -->
            <img
              class="click-tips abs"
              src="./assets/img/click_tips.gif"
              alt=""
            />
          </div>

          <div @click="showRoad('oj')" class="road-oj-btn abs">
            <img class="base-img" src="./assets/img/road_oj_btn.png" alt="" />
            <!-- <div class="light abs"></div> -->
            <img
              class="click-tips abs"
              src="./assets/img/click_tips.gif"
              alt=""
            />
          </div>
        </div>
      </transition>

      <img
        ref="chooseTips"
        class="choose-tips abs"
        src="./assets/img/choose_tips.png"
        alt=""
      />
      <video
        x5-video-player-type="h5-page"
        x-webkit-airplay="true"
        webkit-playsinline
        playsinline="true"
        preload="auto"
        class="video abs"
        src="./assets/media/video_start.mp4"
        ref="startVideo"
      ></video>

      <img
        v-if="showPass"
        @click="passVideo"
        class="pass-btn abs"
        src="./assets/img/pass_btn.png"
        alt=""
      />
    </div>
    <!-- 地图页 -->

    <!-- 钱塘江诗路过渡页 -->
    <transition name="fade">
      <div class="boat-qt-page" ref="boatQtPage" v-show="showWaterQt">
        <img class="cloud abs" src="./assets/img/cloud.png" alt="" />
        <img class="cloud1 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud2 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud3 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="cloud4 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="boat-qt abs" src="./assets/img/boat_qt.png" alt="" />

        <img class="hand abs" src="./assets/img/hand.png" alt="" />
        <img class="hand-tips abs" src="./assets/img/hand_tips.png" alt="" />

        <img
          class="nor-js-moun abs"
          src="./assets/img/nor_js_moun1.png"
          alt=""
        />
        <img
          class="data-moun-js abs"
          src="./assets/img/data_moun_js.png"
          alt=""
        />

        <div class="shi-qt-box abs"></div>
        <img class="title-qt abs" src="./assets/img/title_qt.png" alt="" />
        <img
          class="triangle-qt abs"
          src="./assets/img/triangle_qt.png"
          alt=""
        />

        <video
          x5-video-player-type="h5-page"
          x-webkit-airplay="true"
          webkit-playsinline
          playsinline="true"
          preload="auto"
          class="water-qt abs"
          ref="waterQt"
          loop
          src="./assets/media/water_qt.mp4"
        ></video>
      </div>
    </transition>
    <!-- 钱塘江诗路过渡页 -->

    <!-- 浙东诗路过渡页 -->
    <transition name="fade">
      <div class="boat-zd-page" ref="boatZdPage" v-show="showWaterZd">
        <img class="cloud abs" src="./assets/img/cloud.png" alt="" />
        <img class="cloud1 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud2 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud3 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="cloud4 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="boat-zd abs" src="./assets/img/boat_qt.png" alt="" />

        <img class="hand abs" src="./assets/img/hand.png" alt="" />
        <img class="hand-tips abs" src="./assets/img/hand_tips.png" alt="" />

        <img
          class="nor-xj-moun abs"
          src="./assets/img/nor_xj_moun1.png"
          alt=""
        />
        <img
          class="data-moun-xj abs"
          src="./assets/img/data_moun_xj.png"
          alt=""
        />

        <div class="shi-zd-box abs"></div>
        <img class="title-zd abs" src="./assets/img/title_zd.png" alt="" />
        <img
          class="triangle-zd abs"
          src="./assets/img/triangle_zd.png"
          alt=""
        />

        <video
          x5-video-player-type="h5-page"
          x-webkit-airplay="true"
          webkit-playsinline
          playsinline="true"
          preload="auto"
          class="water-zd abs"
          ref="waterZd"
          loop
          src="./assets/media/water_zd.mp4"
        ></video>
      </div>
    </transition>
    <!-- 浙东诗路过渡页 -->

    <!-- 瓯江诗路过度页 -->
    <transition name="fade">
      <div class="boat-oj-page" ref="boatOjPage" v-show="showWaterOj">
        <img class="cloud abs" src="./assets/img/cloud.png" alt="" />
        <img class="cloud1 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud2 abs" src="./assets/img/cloud1.png" alt="" />
        <img class="cloud3 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="cloud4 abs" src="./assets/img/cloud2.png" alt="" />

        <img class="boat-oj abs" src="./assets/img/boat_oj.png" alt="" />

        <img class="hand abs" src="./assets/img/hand.png" alt="" />
        <img class="hand-tips abs" src="./assets/img/hand_tips.png" alt="" />

        <img
          class="nor-jn-moun abs"
          src="./assets/img/nor_jn_moun1.png"
          alt=""
        />
        <img
          class="data-moun-jn abs"
          src="./assets/img/data_moun_jn.png"
          alt=""
        />

        <div class="shi-oj-box abs"></div>
        <img class="title-oj abs" src="./assets/img/title_oj.png" alt="" />
        <img
          class="triangle-oj abs"
          src="./assets/img/triangle_oj.png"
          alt=""
        />

        <video
          x5-video-player-type="h5-page"
          x-webkit-airplay="true"
          webkit-playsinline
          playsinline="true"
          preload="auto"
          class="water-oj abs"
          ref="waterOj"
          loop
          src="./assets/media/water_oj.mp4"
        ></video>
      </div>
    </transition>
    <!-- 瓯江诗路过度页 -->

    <!-- 结尾页 -->
    <transition name="fade">
      <div class="end-video-page" v-show="showEndVideo">
        <video
          x5-video-player-type="h5-page"
          x-webkit-airplay="true"
          webkit-playsinline
          playsinline="true"
          preload="auto"
          class="end-video"
          src="./assets/media/video_end.mp4"
          ref="endVideo"
        ></video>
        <transition name="fade">
          <div class="btn-wrap abs" v-show="showEndBtn">
            <img
              @click="playAgain"
              class="again-btn"
              src="./assets/img/again_btn.png"
              alt=""
            />
            <img
              @click="showSharePage = true"
              class="share-btn"
              src="./assets/img/share_btn.png"
              alt=""
            />
          </div>
        </transition>
      </div>
    </transition>
    <!-- 结尾页 -->

    <transition name="fade">
      <div
        class="share-page"
        v-show="showSharePage"
        @click="showSharePage = false"
      >
        <img class="share-tips abs" src="./assets/img/share_tips.png" alt="" />
      </div>
    </transition>
  </div>
</template>
<script>
import { wxShare } from "./utils/wxUtils.js";
import { images } from "./assets/js/imgs.js";
import LoadingLayer from "./components/LoadingLayer.vue";
import MountainZd from "./components/MountainZd.vue";
import MountainOj from "./components/MountainOj.vue";
import MountainQt from "./components/MountainQt.vue";
import gsap from "gsap";
import { Howl } from "howler";
export default {
  name: "App",
  data() {
    return {
      qtAudioPlaying: true,
      zdAudioPlaying: true,
      ojAudioPlaying: true,
      progress: 0, // 加载进度
      shwoLoadPage: true,
      showPass: true, // 跳过
      showHomeMap: true, // 显示地图页
      showRoadBtn: false, // 显示诗路按钮
      showWaterQt: false, // 钱塘江诗路过度页
      showWaterZd: false, // 浙东诗路过度页
      showWaterOj: false, // 瓯江诗路过度页
      showMountQt: false, // 钱塘江诗路 诗路一
      showMountZd: false, // 浙东唐诗之路 诗路二
      showMountOj: false, // 瓯江山水诗路 诗路三
      showEndVideo: false, // 结尾视频
      showSharePage: false, // 分享页
      showEndBtn: false,
      visitedQt: false, // 浏览钱塘江诗路
      visitedOj: false, // 浏览瓯江诗路
      visitedZd: false // 浏览浙东诗路
    };
  },
  components: {
    LoadingLayer,
    MountainZd,
    MountainOj,
    MountainQt
  },
  computed: {
    visitedAll() {
      return (
        (this.visitedQt && this.visitedOj) ||
        (this.visitedQt && this.visitedZd) ||
        (this.visitedOj && this.visitedZd)
      );
    }
  },
  created() {
    this.chooseAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/20/2313d9e43b414fa5a6ad065bed1da383/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
    // 静态资源加载
    let l = images.length;
    let loadedNum = 0;
    for (let i = 0; i < l; i++) {
      let image = new Image();
      image.onload = () => {
        loadedNum++;
        this.progress = (loadedNum / l) * 100;
        if (loadedNum === l) {
          console.log("资源加载完成！");
        }
      };
      image.src = images[i];
    }

    // 设置分享
    let ua_str = window.navigator.userAgent.toLowerCase();
    if (/chinabluetv/.test(ua_str)) {
      // 蓝tv app SDK 初始化
      const shareData = {
        showShareBtn: true,
        url: "", //分享的网址链接
        title: "", //分享的标题
        content: "", // 分享的文字
        img: "" // 分享的图片Url
      };
      // eslint-disable-next-line
      this.shareApp = new ShareApp("true", shareData);
      // 设置分享
      this.shareApp.changeShareInfo(shareData);
      // 获取用户信息
      this.shareApp.getUserInfo(res => {
        if (res) {
          var parse = JSON.parse(res);
          window.mToken = parse.access_token;
          console.log("mToken:" + window.mToken);
        } else {
          console.log("未登录");
          window.location.reload();
        }
      });
    } else {
      // 设置微信分享
      wxShare(
        true,
        "跟着诗路•寻富山水间",
        "浙江山区26县激发产业活力，“接力”描绘共富实景。",
        "浙江山区26县激发产业活力，“接力”描绘共富实景。",
        window.location.href,
        "https://ohudong.cztv.com/1/264620/images/share.jpg"
      );
    }
  },
  mounted() {},
  methods: {
    playmusic(name) {
      switch (name) {
        case "qt":
          if (this.qtAudioPlaying) {
            this.$refs.audioQt.pause();
            this.qtAudioPlaying = false;
          } else {
            this.$refs.audioQt.play();
            this.qtAudioPlaying = true;
          }
          break;
        case "zd":
          if (this.zdAudioPlaying) {
            this.$refs.audioZd.pause();
            this.zdAudioPlaying = false;
          } else {
            this.$refs.audioZd.play();
            this.zdAudioPlaying = true;
          }
          break;
        case "oj":
          if (this.ojAudioPlaying) {
            this.$refs.audioOj.pause();
            this.ojAudioPlaying = false;
          } else {
            this.$refs.audioOj.play();
            this.ojAudioPlaying = true;
          }
          break;
        default:
          break;
      }
    },
    passVideo() {
      // console.log(this.$refs.startVideo.duration);
      let duration = this.$refs.startVideo.duration;
      this.$refs.startVideo.currentTime = duration - 0.1;
      this.showPass = false;
    },
    showRoad(name) {
      this.chooseAudio.play();
      this.showHomeMap = false;
      switch (name) {
        case "qt":
          this.$refs.audioQt.play();
          this.qtAudioPlaying = true;
          if (this.visitedQt) {
            this.showMountQt = true;
            return;
          }
          this.showWaterQt = true;
          this.$refs.waterQt.play();
          // eslint-disable-next-line
          const waterQtTl = new gsap.timeline();
          waterQtTl
            .to(
              ".boat-qt-page .cloud",
              { x: 500, y: 200, opacity: 0.3, duration: 1.5 },
              "waterQtTl"
            )
            .to(
              ".boat-qt-page .cloud1",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterQtTl"
            )
            .to(
              ".boat-qt-page .cloud2",
              { x: -500, opacity: 0.3, duration: 1.5 },
              "waterQtTl"
            )
            .to(
              ".boat-qt-page .cloud3",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterQtTl"
            )
            .fromTo(
              ".boat-qt",
              15,
              { x: 500, y: 200, scale: 1, ease: "none" },
              { x: 0, y: 0, scale: 0.5, ease: "none" },
              "waterQtTl+=2"
            )
            .from(
              ".title-qt",
              { y: -20, opacity: 0, duration: 1 },
              "waterQtTl+=1.6"
            )
            .from(
              ".triangle-qt",
              { y: 20, opacity: 0, duration: 1 },
              "waterQtTl+=1.6"
            )
            .from(
              ".shi-qt-box",
              { width: 0, opacity: 0, duration: 2.5 },
              "waterQtTl+=2.5"
            )
            .to(
              ".boat-qt-page .hand",
              { y: -50, duration: 2, repeat: -1 },
              "waterQtTl+=1"
            );

          this.$refs.boatQtPage.addEventListener("touchmove", () => {
            gsap.to(
              [
                ".title-qt",
                ".triangle-qt",
                ".shi-qt-box",
                ".boat-qt",
                ".boat-qt-page .cloud4"
              ],
              { opacity: 0 }
            );
            gsap.to(".water-qt", {
              bottom: "-100%",
              duration: 2.5,
              onComplete: () => {
                this.showWaterQt = false;
                this.showMountQt = true;
              }
            });
            gsap.to(".data-moun-js", { bottom: 0, duration: 2 });
            gsap.to(".nor-js-moun", { bottom: 0, duration: 2 });
          });
          break;
        case "zd":
          this.$refs.audioZd.play();
          this.zdAudioPlaying = true;
          if (this.visitedZd) {
            this.showMountZd = true;
            return;
          }
          this.showWaterZd = true;
          this.$refs.waterZd.play();
          // eslint-disable-next-line
          const waterZdTl = new gsap.timeline();
          waterZdTl
            .to(
              ".boat-zd-page .cloud",
              { x: 500, y: 200, opacity: 0.3, duration: 1.5 },
              "waterZdTl"
            )
            .to(
              ".boat-zd-page .cloud1",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterZdTl"
            )
            .to(
              ".boat-zd-page .cloud2",
              { x: -500, opacity: 0.3, duration: 1.5 },
              "waterZdTl"
            )
            .to(
              ".boat-zd-page .cloud3",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterZdTl"
            )
            .fromTo(
              ".boat-zd",
              15,
              { x: 500, y: 200, scale: 1, ease: "none" },
              { x: 0, y: 0, scale: 0.5, ease: "none" },
              "waterZdTl+=2"
            )
            .from(
              ".title-zd",
              { y: -20, opacity: 0, duration: 1 },
              "waterZdTl+=1.6"
            )
            .from(
              ".triangle-zd",
              { y: 20, opacity: 0, duration: 1 },
              "waterZdTl+=1.6"
            )
            .from(
              ".shi-zd-box",
              { width: 0, opacity: 0, duration: 2.5 },
              "waterZdTl+=2.5"
            )
            .to(
              ".boat-zd-page .hand",
              { y: -50, duration: 2, repeat: -1 },
              "waterZdTl+=1"
            );

          this.$refs.boatZdPage.addEventListener("touchmove", () => {
            gsap.to(
              [
                ".title-zd",
                ".triangle-zd",
                ".shi-zd-box",
                ".boat-zd",
                ".boat-zd-page .cloud4"
              ],
              { opacity: 0 }
            );
            gsap.to(".water-zd", {
              y: "100%",
              duration: 2.5,
              onComplete: () => {
                this.showWaterZd = false;
                this.showMountZd = true;
              }
            });
            gsap.to(".data-moun-xj", { bottom: 0, duration: 2 });
            gsap.to(".nor-xj-moun", { bottom: 0, duration: 2 });
          });
          break;
        case "oj":
          this.$refs.audioOj.play();
          this.ojAudioPlaying = true;
          if (this.visitedOj) {
            this.showMountOj = true;
            return;
          }
          this.showWaterOj = true;
          this.$refs.waterOj.play();
          // eslint-disable-next-line
          const waterOjTl = new gsap.timeline();
          waterOjTl
            .to(
              ".boat-oj-page .cloud",
              { x: 500, y: 200, opacity: 0.3, duration: 1.5 },
              "waterOjTl"
            )
            .to(
              ".boat-oj-page .cloud1",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterOjTl"
            )
            .to(
              ".boat-oj-page .cloud2",
              { x: -500, opacity: 0.3, duration: 1.5 },
              "waterOjTl"
            )
            .to(
              ".boat-oj-page .cloud3",
              { x: 500, opacity: 0.3, duration: 1.5 },
              "waterOjTl"
            )
            .fromTo(
              ".boat-oj",
              15,
              { x: 500, y: 200, scale: 1, ease: "none" },
              { x: 0, y: 0, scale: 0.5, ease: "none" },
              "waterOjTl+=2"
            )
            .from(
              ".title-oj",
              { y: -20, opacity: 0, duration: 1 },
              "waterOjTl+=1.6"
            )
            .from(
              ".triangle-oj",
              { y: 20, opacity: 0, duration: 1 },
              "waterOjTl+=1.6"
            )
            .from(
              ".shi-oj-box",
              { width: 0, opacity: 0, duration: 2.5 },
              "waterOjTl+=2.5"
            )
            .to(
              ".boat-oj-page .hand",
              { y: -50, duration: 2, repeat: -1 },
              "waterOjTl+=1"
            );

          this.$refs.boatOjPage.addEventListener("touchmove", () => {
            gsap.to(
              [
                ".title-oj",
                ".triangle-oj",
                ".shi-oj-box",
                ".boat-oj",
                ".boat-oj-page .cloud4"
              ],
              { opacity: 0 }
            );
            gsap.to(".water-oj", {
              y: "100%",
              duration: 2.5,
              onComplete: () => {
                this.showWaterOj = false;
                this.showMountOj = true;
              }
            });
            gsap.to(".data-moun-jn", { bottom: 0, duration: 2 });
            gsap.to(".nor-jn-moun", { bottom: 0, duration: 2 });
          });
          break;
        default:
          break;
      }
    },
    hideRoad(name) {
      console.log(name);
      this.showHomeMap = true;
      switch (name) {
        case "qt":
          this.$refs.audioQt.pause();
          this.showMountQt = false;
          this.visitedQt = true;
          break;
        case "zd":
          this.$refs.audioZd.pause();
          this.showMountZd = false;
          this.visitedZd = true;
          break;
        case "oj":
          this.$refs.audioOj.pause();
          this.showMountOj = false;
          this.visitedOj = true;
          break;
        default:
          break;
      }
    },
    start() {
      this.shwoLoadPage = false;
      this.$refs.startVideo.play();
      this.$refs.endVideo.play();
      setTimeout(() => {
        this.$refs.endVideo.pause();
      }, 100);
      this.$refs.startVideo.addEventListener("ended", () => {
        this.$refs.chooseTips.style.display = "block";
        this.showRoadBtn = true;
      });
    },
    endVisit(name) {
      switch (name) {
        case "qt":
          this.$refs.audioQt.pause();
          this.showMountQt = false;
          break;
        case "zd":
          this.$refs.audioZd.pause();
          this.showMountZd = false;
          break;
        case "oj":
          this.$refs.audioOj.pause();
          this.showMountOj = false;
          break;
        default:
          break;
      }
      this.showEndVideo = true;
      this.$refs.endVideo.play();
      this.$refs.endVideo.addEventListener("timeupdate", () => {
        // console.log(this.$refs.endVideo.currentTime);
        if (this.$refs.endVideo.currentTime > 28) {
          this.showEndBtn = true;
        }
      });
    },
    playAgain() {
      window.location.reload();
    }
  }
};
</script>

<style lang="less">
html,
body,
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.base-img {
  display: block;
  width: 100%;
}
.audio-box {
  width: 56px;
  height: 56px;
  top: 20px;
  right: 120px;
  position: absolute;
  z-index: 50;
  .audio-on {
    width: 100%;
    height: 100%;
    animation: musicAni 2s linear infinite;
  }
  .audio-off {
    width: 100%;
    height: 100%;
  }
}
.enter-btn {
  width: 260px;
  height: 68px;
  line-height: 68px;
  text-align: center;
  font-size: 28px;
  color: #fff;
  z-index: 5;
  background-color: #2c3e50;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50px;
}
.back-btn {
  position: absolute;
  width: 630px;
  height: 100px;
  bottom: 196px;
  left: 50%;
  margin-left: -315px;
  z-index: 30;
  border-radius: 12px;
  opacity: 0;
  display: none;
  .back-btn-txt {
    width: 354px;
    height: 29px;
    left: 107px;
    top: 36px;
  }
}
.end-btn {
  position: absolute;
  width: 129px;
  height: 40px;
  bottom: 103px;
  left: 50%;
  margin-left: -129/2px;
  opacity: 0;
  z-index: 20;
  display: none;
}
.home-map {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: url("./assets/img/map_bg.jpg") no-repeat center;
  background-size: 100% 100%;
  .pass-btn {
    width: 78px;
    height: 34px;
    transform: translate(0, 0, 0);
    top: 30px;
    right: 30px;
    z-index: 12;
  }
  .map-intro {
    width: 613px;
    height: 210px;
    top: 101px;
    left: 50%;
    transform: translateX(-50%);
  }
  .video {
    width: 100%;
    height: auto;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    object-fit: cover;
    // background-color: #fff;
  }
  .map-box {
    width: 726px;
    height: 766px;
    right: 0;
    top: 50%;
    margin-top: -350px;
    z-index: 10;
    .map {
      width: 100%;
      height: 100%;
    }
    .click-tips {
      display: block;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      // background-color: #fff;
      top: 50%;
      left: 50%;
      margin-left: -60/2px;
      margin-top: -60/2px;
    }
    .road-qt-btn {
      width: 66px;
      height: 276px;
      top: 20px;
      left: 168px;
      filter: drop-shadow(5px 5px 6px rgba(0, 0, 0, 0.3));
      .light {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        mask: url("./assets/img/road_qt_btn.png");
        mask-size: 100%;
        &:before {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0%;
          top: -100%;
          background: rgb(255, 255, 255);
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 25%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 75%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: LightMove 1.5s 0.8s ease-in-out forwards;
        }
      }
      &.disable {
        pointer-events: none;
      }
    }
    .road-zd-btn {
      width: 66px;
      height: 324px;
      top: 248px;
      right: 50px;
      .light {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        mask: url("./assets/img/road_zd_btn.png");
        mask-size: 100%;
        &:before {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0%;
          top: -100%;
          background: rgb(255, 255, 255);
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 25%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 75%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: LightMove 1.5s 0.8s ease-in-out forwards;
        }
      }
      &.disable {
        pointer-events: none;
      }
    }
    .road-oj-btn {
      width: 66px;
      height: 307px;
      bottom: -46px;
      left: 47px;
      .light {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        mask: url("./assets/img/road_oj_btn.png");
        mask-size: 100%;
        &:before {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0%;
          top: -100%;
          background: rgb(255, 255, 255);
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 25%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 75%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: LightMove 1.5s 0.8s ease-in-out forwards;
        }
      }
      &.disable {
        pointer-events: none;
      }
    }
  }
  .choose-tips {
    width: 302px;
    height: 26px;
    bottom: 89px;
    left: 50%;
    // transform: translateX(-50%);
    margin-left: -302/2px;
    animation: fadeInOut 1.2s ease-out infinite;
    z-index: 5;
    display: none;
  }
}
.boat-qt-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #fff;
  .nor-js-moun {
    width: 100%;
    height: auto;
    bottom: 554px;
    left: 0;
  }
  .data-moun-js {
    width: 100%;
    height: auto;
    bottom: 554px;
    left: 0;
  }
  .water-qt {
    width: 100%;
    height: 954px;
    object-fit: fill;
    left: 0;
    bottom: 0;
  }
  .shi-qt-box {
    width: 145px;
    height: 452px;
    top: 20px;
    left: 538px;
    z-index: 9;
    background: url("./assets/img/shi_qt.png") no-repeat left;
    background-size: auto 100%;
  }
  .title-qt {
    width: 216px;
    height: 49px;
    top: 53px;
    left: 65px;
    z-index: 9;
  }
  .triangle-qt {
    width: 194px;
    height: 50px;
    top: 114px;
    left: 76px;
    z-index: 9;
  }
  .boat-qt {
    width: 426px;
    height: 517px;
    bottom: 490px;
    // right: -426px;
    left: -80px;
    z-index: 10;
  }
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .cloud {
    width: 200%;
    height: 1334px;
    top: -10%;
    left: -50%;
    z-index: 10;
  }
  .cloud1 {
    width: 200%;
    top: -20%;
    left: -50%;
    z-index: 10;
  }
  .cloud2 {
    width: 200%;
    top: 40%;
    left: -50%;
    z-index: 10;
  }
  .cloud3 {
    width: 200%;
    left: -50%;
    top: 60%;
    z-index: 10;
  }
  .cloud4 {
    width: 150%;
    left: 6%;
    top: -15%;
    z-index: 7;
    transform: translate(0, 0, 0);
  }
}
.boat-zd-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #fff;
  .nor-xj-moun {
    width: 100%;
    height: auto;
    bottom: 554px;
    left: 0;
  }
  .data-moun-xj {
    width: 100%;
    height: auto;
    bottom: 580px;
    left: 0;
  }
  .water-zd {
    width: 100%;
    height: 954px;
    object-fit: fill;
    left: 0;
    bottom: 0;
  }
  .shi-zd-box {
    width: 144px;
    height: 333px;
    top: 54px;
    left: 538px;
    z-index: 9;
    background: url("./assets/img/shi_zd.png") no-repeat left;
    background-size: auto 100%;
  }
  .title-zd {
    width: 262px;
    height: 49px;
    top: 53px;
    left: 65px;
    z-index: 9;
  }
  .triangle-zd {
    width: 108px;
    height: 20px;
    top: 114px;
    left: 76px;
    z-index: 9;
  }
  .boat-zd {
    width: 426px;
    height: 517px;
    bottom: 490px;
    // right: -426px;
    left: -80px;
    z-index: 10;
  }
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .cloud {
    width: 200%;
    height: 1334px;
    top: -10%;
    left: -50%;
    z-index: 10;
  }
  .cloud1 {
    width: 200%;
    top: -20%;
    left: -50%;
    z-index: 10;
  }
  .cloud2 {
    width: 200%;
    top: 40%;
    left: -50%;
    z-index: 10;
  }
  .cloud3 {
    width: 200%;
    left: -50%;
    top: 60%;
    z-index: 10;
  }
  .cloud4 {
    width: 150%;
    left: 6%;
    top: -15%;
    z-index: 7;
    transform: translate(0, 0, 0);
  }
}
.boat-oj-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #fff;
  .nor-jn-moun {
    width: 100%;
    height: auto;
    bottom: 554px;
    left: 0;
  }
  .data-moun-jn {
    width: 100%;
    height: auto;
    bottom: 580px;
    left: 0;
  }
  .water-oj {
    width: 100%;
    height: 954px;
    object-fit: fill;
    left: 0;
    bottom: 0;
  }
  .shi-oj-box {
    width: 143px;
    height: 333px;
    top: 54px;
    left: 538px;
    z-index: 9;
    background: url("./assets/img/shi_oj.png") no-repeat left;
    background-size: auto 100%;
  }
  .title-oj {
    width: 262px;
    height: 49px;
    top: 53px;
    left: 65px;
    z-index: 9;
  }
  .triangle-oj {
    width: 194px;
    height: 84px;
    top: 114px;
    left: 76px;
    z-index: 9;
  }
  .boat-oj {
    width: 426px;
    height: 517px;
    bottom: 490px;
    // right: -426px;
    left: -80px;
    z-index: 10;
  }
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .cloud {
    width: 200%;
    height: 1334px;
    top: -10%;
    left: -50%;
    z-index: 10;
  }
  .cloud1 {
    width: 200%;
    top: -20%;
    left: -50%;
    z-index: 10;
  }
  .cloud2 {
    width: 200%;
    top: 40%;
    left: -50%;
    z-index: 10;
  }
  .cloud3 {
    width: 200%;
    left: -50%;
    top: 60%;
    z-index: 10;
  }
  .cloud4 {
    width: 150%;
    left: 6%;
    top: -15%;
    z-index: 7;
    transform: translate(0, 0, 0);
  }
}
.end-video-page {
  position: fixed;
  z-index: 50;
  width: 100%;
  height: 100%;
  .end-video {
    object-fit: fill;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn-wrap {
    width: 470px;
    height: 54px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 200px;
    z-index: 5;
    display: flex;
    justify-content: space-between;
  }
  .again-btn {
    width: 210px;
    height: 54px;
  }
  .share-btn {
    width: 210px;
    height: 54px;
  }
}
.share-page {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 55;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  .share-tips {
    width: 183px;
    height: 176px;
    top: 10px;
    right: 10px;
  }
}
@keyframes musicAni {
  from {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes clickAni {
  from {
    opacity: 0;
    transform: scale(0);
  }
  70% {
    opacity: 1;
    transform: scale(0.8);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes LightMove {
  from {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 200%, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInOut {
  from {
    opacity: 0.6;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  to {
    opacity: 0.6;
  }
}
@keyframes cloudAni {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  30% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: scale(6);
  }
}
</style>
